export default __webpack_public_path__ + "755e96d0417b126323bfd02e3f363c3c.png";